import { useQuery } from "@tanstack/react-query";
import { useWorkspace } from "@/shared/hooks/api/useWorkspace";
import { KnowledgeBaseEntry } from "../types/knowledge-entry";
import { get, makeApiError } from "@/shared/utils/fetchApi";

interface KnowledgeBaseResponse {
  data: KnowledgeBaseEntry[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export function useKnowledge() {
  const { currentWorkspace } = useWorkspace();

  return useQuery({
    queryKey: ["knowledge-base", currentWorkspace?.id],
    queryFn: async () => {
      if (!currentWorkspace?.id) {
        console.warn("[useKnowledge] No workspace ID available");
        return null;
      }

      const endpoint = `/knowledge-bases/by-product/${currentWorkspace.id}`;

      try {
        const response = await get<KnowledgeBaseResponse>(endpoint);

        if (typeof response === "string") {
          throw makeApiError("Invalid API response format", {
            code: "E_UNEXPECTED_RESPONSE",
          });
        }

        // Retorna o primeiro knowledge ativo, se houver
        return response.data.length > 0 ? response.data[0] : null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (error: any) {
        console.error("[useKnowledge] Error fetching knowledge base:", {
          error,
          message: error?.message,
          response: error?.response,
        });
        throw error;
      }
    },
    enabled: !!currentWorkspace?.id,
    staleTime: 5 * 60 * 1000, // 5 minutos
    retry: false,
  });
}
